export default {
    login: {
        title: "Log in to your dashboard",
        logIn: "Log in",
        username: "Username",
        password: "Password",
        any: "any",
        thirdparty: "Or connect with",
        thirdpartyTips:
            "Can not be simulated on local, so please combine you own business simulation! ! !",
        email: "Email",
        relogin_title: "Please relogin",
        relogin: "Relogin",
    },
    common: {
        switch_property: "Switch Property",
        bookings: "Bookings",
        visitors: "Visitors",
        forms: "Forms",
        billings: "Billings",
        coming_soon: "Coming Soon",
        dashboard: "Dashboard",
        parking: "Parking",
        my_home: "My Home",
        my_places: "My Places",
        hi: "Hi",
        my_balance: "My Balance",
    },
    button: {
        back: "Back",
    },
    messages: {
        copied_success: "Copied Success",
        login_success: "Login Success",
        logout_success: "Logout Success",
    },
    validations: {
        username_validate: "username is required",
        password_validate: "password is required",
    },
    tabs: {
        invoice: "Invoice",
        statement: "Statement",
        payment_history: "Payment History",
    },
};
